import { useEffect } from 'react';
import { useSession } from './useSession';
import {
  discussionsService,
  useDiscussionStore,
  DEFAULT_DISCUSSION_PREFS,
} from '@/core/services/discussionsService';

export function useDiscussions() {
  const { currentUser } = useSession();
  const owner = currentUser?.id ?? null;
  const state = useDiscussionStore();
  useEffect(() => {
    discussionsService.scope(owner);
    if (owner) void discussionsService.load(owner);
  }, [owner]);
  return {
    owner,
    prefs: state.owner === owner ? state.prefs : DEFAULT_DISCUSSION_PREFS,
    follows: state.owner === owner ? state.follows : [],
    posts: state.owner === owner ? state.posts : {},
    ready: state.owner === owner && state.ready,
    error: state.owner === owner ? state.error : null,
    refresh: () => (owner ? discussionsService.load(owner, true) : Promise.resolve()),
  };
}
